import axios from 'axios';
import schemeApi from '../schemes/schemeApi';
let {urlLogin, urlLoginSms, urlLogout, urlCheckToken, urlCheckPhone} = schemeApi;

// сервис аутентификации
let serviceAuth = {
    /**
     * получить токен юзера из браузера
     * @returns {object}
     */
    getAuthToken() {
        return localStorage.getItem('AUTH_TOKEN');
    },
    /**
     * получить права юзера из браузера
     * @returns {object}
     */
    getPermissions() {
        return JSON.parse(localStorage.getItem('USER_PERMISSIONS'));
    },
    /**
     * получить профиль юзера из браузера
     * @returns {object}
     */
    getProfile() {
        return JSON.parse(localStorage.getItem('USER_PROFILE'));
    },
    /**
     * установить токен аутентификации в браузер
     * @param {object} token - токен
     */
    setAuthToken(token) {
        if (token === null)
            localStorage.removeItem('AUTH_TOKEN');
        else 
            localStorage.setItem('AUTH_TOKEN', token);
    },
    /**
     * установить права в браузер
     * @param {object} token - токен
     */
    setPermissions(permissions) {
        if (permissions === null)
            localStorage.removeItem('USER_PERMISSIONS');
        else 
            localStorage.setItem('USER_PERMISSIONS', JSON.stringify(permissions));
    },
    /**
     * установить профиль в браузер
     * @param {object} profile - профиль
     */
    setProfile(profile) {
        if (profile === null)
            localStorage.removeItem('USER_PROFILE');
        else
            localStorage.setItem('USER_PROFILE', JSON.stringify(profile));
    },
    /**
     * залогинен ли пользователь
     * @returns {boolean}
     */
    isLogin() {
        let token = this.getAuthToken();
        return token !== null;
    },
    /**
     * аутентификация
     * @async
     * @param {object} loginData - данные для login
     * @returns {object}
     */
    async login(loginData) {
        let postLoginData = {
            'email': loginData.login,
            'password': loginData.password
        }
        try {
            let {data = {}} = await axios.post(urlLogin, postLoginData);
            let {status = -1, token = null, permissions = {}, message = '', profile = {}} = data;
            let succes = (status === 10) ? true : false;
            if (succes) {
                this.setAuthToken(token);
                this.setPermissions(permissions);
                this.setProfile(profile);
            }
            return {
                succes: succes,
                data: data,
                message: message
            }
        }
        catch (error) {
            return {
                succes: false,
                data: false,
                error: error,
            }
        }
    },
    /**
     * аутентификация
     * @async
     * @param {object} loginData - данные для login
     * @returns {object}
     */
    // async loginSms(loginData) {
    //     let postLoginData = {
    //         'phone': loginData.phone,
    //         'code': loginData.code
    //     }
    //     try {
    //         let {data = {}} = await axios.post(urlLoginSms, postLoginData);
    //         let {status = -1, token = null, permissions = {}, message = ''} = data;
    //         let succes = (status === 10) ? true : false;
    //         if (succes) {
    //             this.setAuthToken(token);
    //             this.setPermissions(permissions);
    //         }
    //         return {
    //             succes: succes,
    //             data: data,
    //             message: message
    //         }
    //     }
    //     catch (error) {
    //         return {
    //             succes: false,
    //             data: false,
    //             error: error,
    //         }
    //     }
    // },
    /**
     * аутентификация
     * @async
     * @param {object} loginData - данные для login
     * @returns {object}
     */
    async loginSms(loginData) {
        let postLoginData = {
            'email': loginData.login,
            'password': loginData.password,
            'code': loginData.code
        }
        try {
            let {data = {}} = await axios.post(urlLoginSms, postLoginData);
            let {status = -1, token = null, permissions = {}, message = '', profile = {}} = data;
            let succes = (status === 10) ? true : false;
            if (succes) {
                this.setAuthToken(token);
                this.setPermissions(permissions);
                this.setProfile(profile);
            }
            return {
                succes: succes,
                data: data,
                message: message
            }
        }
        catch (error) {
            return {
                succes: false,
                data: false,
                error: error,
            }
        }
    },
    /**
     * проверка телефона
     * @async
     * @param {object} checkData - данные для отправки СМС
     * @returns {object}
     */
    // async checkPhone(checkData) {
    //     let postData = {
    //         'phone': checkData.phone
    //     };
    //     // console.log(postData);
    //     try {
    //         let {data = {}} = await axios.post(urlCheckPhone, postData);

    //         return {
    //             phone: data.success ? postData.phone : false,
    //             message: data.success ? data.success : data.error
    //         }
    //     }
    //     catch (error) {
    //         return {
    //             phone: false
    //         }
    //     }
    // },
    /**
     * проверка телефона
     * @async
     * @param {object} checkData - данные для отправки СМС
     * @returns {object}
     */
    async checkPhone(checkData) {
        let postData = {
            'email': checkData.login,
            'password': checkData.password
        };
        try {
            let {data = {}} = await axios.post(urlCheckPhone, postData);
            let {success = false, error = false} = data;
            return {
                succes: success,
                message: error
            }
        }
        catch (error) {
            return {
                succes: false,
                error: error
            }
        }
    },
    /**
     * выйти из системы
     * @async
     * @returns {object}
     */
    async logout() {
        let token = this.getAuthToken();
        try {
            let reqConfig = {
                headers: {
                    'X-Auth-Token': token
                }
            }
            let result = await axios.post(urlLogout, {}, reqConfig);
            let {status} = result;
            let succes = (status === 200) ? true : false;
            if (succes) {
                this.setAuthToken(null);
                this.setPermissions(null);
                this.setProfile(null);
            }
            return {
                succes: succes,
            }
        }
        catch(error) {
            return {
                succes: false,
                error: error,
            }
        }
    },
    /**
     * проверка токена
     * @async
     * @returns {object}
     */
    async checkToken() {
        let token = this.getAuthToken();
        try {
            let reqConfig = {
                headers: {
                    'X-Auth-Token': token
                }
            }
            let result = await axios.post(urlCheckToken, {}, reqConfig);
            let {status = null} = result;
            return {
                status: status,
            }
        }
        catch(error) {
            let status = null;
            if (error.response) {
                status = error.response.status;
            }
            return {
                status: status,
                error: error
            }
        }
    },
    /**
     * проверить права
     * @param {string} activeProjectId - активный проект
     * @param {array} permissions - права
     */
    checkPermission(activeProjectId, permission) {
        let permissions = this.getPermissions();
        if (permissions !== null) {
            let permissionsActiveProject = permissions[activeProjectId];
            if (typeof permissionsActiveProject !== 'undefined') {
                if(permissionsActiveProject.includes(permission)) {
                   return true; 
                }
            }
        }
        return false;
    },
};

export default serviceAuth;